/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_Native_AInputs */

const en_mk_faq_native_a = /** @type {(inputs: Mk_Faq_Native_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, through the official agent login on your computer, provided your account includes access. Connect through Desktop or CLI, then select the agent and its login on the Build page. Planning, chat, and review use Bystep AI or an API connection selected separately.`)
};

const id_mk_faq_native_a = /** @type {(inputs: Mk_Faq_Native_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa melalui login resmi agent pada komputer sendiri, selama akunmu mendukung akses tersebut. Hubungkan komputer melalui Desktop atau CLI, lalu pilih agent dan login miliknya di halaman Bangun. Rencana, chat, dan review memakai AI Bystep atau koneksi API yang dipilih terpisah.`)
};

/**
* | output |
* | --- |
* | "Yes, through the official agent login on your computer, provided your account includes access. Connect through Desktop or CLI, then select the agent and its ..." |
*
* @param {Mk_Faq_Native_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_native_a = /** @type {((inputs?: Mk_Faq_Native_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_Native_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_native_a(inputs)
	return en_mk_faq_native_a(inputs)
});